<h2 mat-dialog-title>Wybierz kategorię InPost</h2>
<mat-dialog-content>
  <div *ngIf="loading" fxLayout="row" fxLayoutAlign="center center" style="padding: 40px;">
    <mat-spinner diameter="40"></mat-spinner>
  </div>
  <div *ngIf="!loading" class="category-tree">
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <!-- Leaf node -->
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
        <button mat-icon-button disabled></button>
        <span class="node-name" [class.selected]="isSelected(node)" (click)="selectNode(node)">
          {{ node.name }}
        </span>
      </mat-tree-node>

      <!-- Expandable node -->
      <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
        <button mat-icon-button matTreeNodeToggle>
          <mat-icon>{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
        </button>
        <span class="node-name" [class.selected]="isSelected(node)" (click)="selectNode(node)">
          {{ node.name }}
        </span>
      </mat-tree-node>
    </mat-tree>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <div *ngIf="selectedCategory" style="flex: 1; padding-left: 16px; color: #666; font-size: 12px;">
    {{ selectedCategory.name }} ({{ selectedCategory.leaf ? 'liść' : 'kategoria nadrzędna' }}) {{ selectedCategory.id }}
  </div>
  <button mat-button (click)="cancel()">Anuluj</button>
  <button mat-raised-button color="primary" [disabled]="!selectedCategory || !selectedCategory.leaf" (click)="confirm()">
    Wybierz
  </button>
</mat-dialog-actions>
